export enum SettingsManagerFont {
  Default = 'default', // poppins
  SulSans = 'sulsans',
}
